import React from 'react';
import { THEMES } from '../../utils/constants';

export const Card = ({ children, className = "", onClick, element = 'air', style = {} }) => {
    const theme = THEMES[element] || THEMES['air'];
    return (
        <div 
            onClick={onClick} 
            style={style}
            className={`bg-slate-900 border border-slate-800 ${onClick ? theme.hover : ''} rounded-xl p-4 md:p-6 shadow-xl transition-all ${className} ${onClick ? `cursor-pointer hover:scale-[1.01] hover:border-${theme.tailwind}` : ''}`}
        >
            {children}
        </div>
    );
};